<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
			<p-toast key="toastmsg"></p-toast>

			<div class="mainDivHeader">
				<div class="leftdiv">
					<h4>Subscription History - <span>{{userName | titlecase}} </span>
						<span > ({{profileDetails?.mobileNumber}})</span>
						<span class="badge">{{ totalRecords }}</span></h4>
				</div>

				<div class="rightDiv">
					<button class="exportBTn" pTooltip="XLS" tooltipPosition="bottom" (click)="exportExcel()"> <span><img
						src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				</div>
			</div>  

        <div class="mainDivBody">
            <div class="date-filterDiv">
              <ul class="filtersList">
                <li>
                    <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                        optionLabel="label"></p-dropdown>
                </li>
                <li>
                    <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                    class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                </li>
                <li>
                    <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                    class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                </li>
                <li>
                    <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                    <button (click)="loadUserSubscriptions($event)" class="searchFilterBtn">
                      <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                    </button>
                </li>
                <li>
                    <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                    <button (click)="clear()" class="clearFilterBtn">
                      <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                    <span>Clear All</span>
                    </button>
                </li>
              </ul>
          </div>

          <div class="maintableDiv">
            <div class="tableParanet">
			<p-table class=" expandable" #dt [value]="userSubscriptionsList" [paginator]="true" [rows]="10" [lazy]="true"
				[scrollable]="true" scrollHeight="auto" scrollDirection="both"
				(onLazyLoad)="loadUserSubscriptions($event)" [totalRecords]="totalRecords" [loading]="loading"
				[rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th pfrozencolumn="" class="p-element" style="left: 0px;"
							pSortableColumn="amount">
							<div class="p-d-flex p-jc-between p-ai-center">
								Amount
								<p-sortIcon field="amount"></p-sortIcon>
							</div>
						</th>
						<th class="col-180" pSortableColumn="invoiceId">
							<div class="p-d-flex p-jc-between p-ai-center">
								Invoice Id
								<p-sortIcon field="invoiceId"></p-sortIcon>
							</div>
						</th>
						<th class="col-180" pSortableColumn="receiptId">
							<div class="p-d-flex p-jc-between p-ai-center">
								Order Id
								<p-sortIcon field="receiptId"></p-sortIcon>
							</div>
						</th>
						<th class="col-150" pSortableColumn="paymentId">
							<div class="p-d-flex p-jc-between p-ai-center">
								Payment Id
								<p-sortIcon field="paymentId"></p-sortIcon>
							</div>
						</th>
						<th class="col-150" pSortableColumn="transactionDate">
							<div class="p-d-flex p-jc-between p-ai-center">
								Transaction Date
								<p-sortIcon field="transactionDate"></p-sortIcon>
							</div>
						</th>

						<th pSortableColumn="expiryDate" class="col-180">
							<div class="p-d-flex p-jc-between p-ai-center">
								Expiry Date
								<p-sortIcon field="expiryDate"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="status" class="statusTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Payment Status
								<p-sortIcon field="status"></p-sortIcon>
							</div>
						</th>
						<th class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right" >
							<div class="p-d-flex p-jc-between p-ai-center">
								Action
							</div>
						</th>
					</tr>
					<tr>
						<th [ngSwitch]="amount" pfrozencolumn="" class="p-element">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amount', 'contains')"
								[value]="dt.filters['amount'] ? dt.filters['amount'].value : ''" />
						</th>
						<th [ngSwitch]="invoiceId" class="col-180">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'invoiceId', 'contains')"
								[value]="dt.filters['invoiceId'] ? dt.filters['invoiceId'].value : ''" />
						</th>
						<th [ngSwitch]="receiptId" class="col-180">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'receiptId', 'contains')"
								[value]="dt.filters['receiptId'] ? dt.filters['receiptId'].value : ''" />
						</th>
						<th [ngSwitch]="paymentId" class="col-150">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'paymentId', 'contains')"
								[value]="dt.filters['paymentId'] ? dt.filters['paymentId'].value : ''" />
						</th>
						<th [ngSwitch]="transactionDate" class="col-150">
							<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true" inputId="calendar"
								dateFormat="dd-mm-yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'transactionDate', 'dateIs')"
								[showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
								yearRange="2000:2030" showButtonBar="true" [(ngModel)]="transvalue"></p-calendar>
						</th>

						<th [ngSwitch]="expiryDate" class="col-180">
							<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true" inputId="calendar"
								dateFormat="dd-mm-yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'expiryDate', 'dateIs')"
								[showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
								yearRange="2000:2030" showButtonBar="true" [(ngModel)]="expiryvalue"></p-calendar>
						</th>
						<th [ngSwitch]="paymentStatus" class="statusTD">
							<!-- <input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'paymentStatus', 'contains')"
								[value]="dt.filters['paymentStatus'] ? dt.filters['paymentStatus'].value : ''" /> -->
							<p-dropdown #pDropDownId [options]="statuses"
								(onChange)="setDownloadFlag(); dt.filter($event.value, 'paymentStatus', 'equals')"
								styleClass="p-column-filter" placeholder="Select Status" [showClear]="true"
								appendTo="body">
								<ng-template let-option pTemplate="item">
									<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
								</ng-template>
							</p-dropdown>
						</th>


						<th class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right" >
							<!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->
							<!-- <button pButton pRipple label="Columns" icon="pi pi-plus"
								[ngClass]="hide ? 'show-col p-button p-button-secondary p-button-rounded ' : 'hide-col p-button-secondary p-button-rounded'"
								(click)="setDownloadFlag(); addColumns()"></button>
							<button pButton pRipple label="Columns" icon="pi pi-minus"
								[ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
								(click)="setDownloadFlag(); removeColumns()"></button> -->
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-user>
					<tr class="p-selectable-row">
						<td pfrozencolumn="" class="p-element"
							style="left: 0px; z-index: 1001; display: flex;">
							{{user.totalAmount}}
						</td>
						<td class="col-180">
							{{user.invoiceId}}
						</td>
						<td class="col-180">
							{{user.orderId}}
						</td>
						<td class="col-150">
							{{user.paymentId}}
						</td>
						<td class="col-150">
							{{user.createdAt| date: 'dd/MM/yyyy'}}
						</td>

						<td class="col-180">
							{{user.endDate| date: 'dd/MM/yyyy'}}
						</td>
						<td class="statusTD">
							

							<div class="checkbox p-d-flex align-items-center">
								<!-- <p-inputSwitch [(ngModel)]="user.showFree" (onChange)="markFree(user.id, user.paymentStatus)"></p-inputSwitch> -->
							
								<span class="tag_value"
									*ngIf="user.paymentStatus === 'created' || user.paymentStatus === 'free'">{{user.paymentStatus | titlecase}}
								</span>
								<span *ngIf="user.paymentStatus === 'pre_order'">Preorder</span>
							<span *ngIf="user.paymentStatus === 'expire'">Expired</span>
							<span *ngIf="user.paymentStatus != 'pre_order' && user.paymentStatus != 'expire' && user.paymentStatus != 'created' && user.paymentStatus != 'free'">{{user.paymentStatus
								|
								titlecase}}</span>
							</div>
							<!-- <span class="d-flex align-items-center" style="gap: 10px;"
								*ngIf="user.status === 'created' || user.status === 'free'">{{user.status |
								titlecase}}
							
								<p-inputSwitch [(ngModel)]="user.showFree"
									(onChange)="markFree(user.id, user.status)"></p-inputSwitch>
							</span> -->
						</td>


						<td class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right" >
							    <ul class="actionList">
									<li *ngIf="user.invoiceFile">
										<button  title="INVOICE" class="downloadpdfBTN p-mr-2" (click)="downloadPdf(user.invoiceFile)">
											<img src="../../../assets/images/backend-image/common-images/pdf-icon.png">
										</button>
									</li>

									<li *ngIf="!user.invoiceFile">
										<button  pButton pRipple icon="pi pi-sync" title="Regenerate Invoice"
											class="imageBtn regenrateIcon p-button-rounded p-button-info p-mr-2"
											(click)="sendInvoice(user.id)" pTooltip="Regenerate PDF" tooltipPosition="bottom" ></button>
									</li>

									<!-- <li *ngIf="user.status === 'free' || user.status === 'created' || user.status === 'paid'">
										<button  (click)="editTrasaction(user)" class="editBtn">
											<img src="../../../assets/images/backend-image/common-images/editeBtn.svg">
										</button>
									</li> -->
								</ul>    
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Subscription history not found.</td>
					</tr>
				</ng-template>
				<!-- <ng-template pTemplate="summary">
					<div class="p-d-flex p-ai-center p-jc-between">
						In total there are {{totalRecords }} Academy Payments.
					</div>
				</ng-template> -->
			</p-table>
			</div>
		  </div>
		</div>



		<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
		<p-dialog   [(visible)]="editTransaction" [modal]="true" [style]="{width: '400px'}" header="Edit Payment Details"
			[breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false"
			[resizable]="false" (onHide)="editTransactionClose()" id="dateChangePopup">
			<form [formGroup]="editPaymentForm" *ngIf="this.editPaymentForm">
				<div>
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12">
							<label for="amount">Start Date: <span class="mandatory-fields">*</span></label>
							<p-calendar appendTo="body" placeholder="Select Subscription Start Date" formControlName="transactionDate"
								class="p-column-filter" monthNavigator="true" yearNavigator="true" yearRange="{{yearRange}}"
								inputId="calendar" dateFormat="dd-mm-yy" [readonlyInput]="true" [showIcon]="true"
								(onSelect)="setStartDate($event)"
								[ngClass]="{ 'is-invalid': transactionSubmitted && f.transactionDate.errors }"
								[minDate]="minimumDate">
							</p-calendar>
							<div *ngIf="transactionSubmitted && f.transactionDate.errors" class="invalid-feedback">
								<div *ngIf="f.transactionDate.errors.required">Subscription Start Date is required</div>
								<div *ngIf="f.transactionDate.errors.startDateError">Start Date should be less than End Date
								</div>
							</div>
						</div>
					</div>
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12">
							<label for="enddt">End Date: <span class="mandatory-fields">*</span></label>
							<p-calendar appendTo="body" placeholder="Select Subscription End Date" formControlName="expiryDate"
								class="p-column-filter" monthNavigator="true" yearNavigator="true" yearRange="{{yearRange}}"
								inputId="calendar" dateFormat="dd-mm-yy" [readonlyInput]="true" [showIcon]="true"
								(onSelect)="setEndDate($event)"
								[ngClass]="{ 'is-invalid': transactionSubmitted && f.expiryDate.errors }"
								[minDate]="minimumDate">
							</p-calendar>
							<div *ngIf="transactionSubmitted && f.expiryDate.errors" class="invalid-feedback">
								<div *ngIf="f.expiryDate.errors.required">Subscription End Date is required</div>
							</div>
						</div>
					</div>
				</div>

			<div class="modalFooter">
				<button type="button" (click)="onSubmit()" pButtonlabel="Submit"  pButton label="Submit"
					class="saveBtn" style="width: auto"></button></div>

			</form>
		</p-dialog>
	</div>
</div>